import Results from "client/common/components/results/Results";
import { ProductListSource } from "client/analytics/types";
import ProductCardList from "client/products/components/ProductCardList";
import ProductCardListHeader from "client/products/components/ProductCardListHeader";

import { useCollectionSearch } from "../hooks";
import { StorefrontCollection } from "../types";

import styles from "../styles/CollectionResults.module.less";

type CollectionResultsProps = {
  collection: StorefrontCollection;
  /** Which surface is reporting the list. */
  listSource: ProductListSource;
};

const CollectionResults = ({ collection, listSource }: CollectionResultsProps) => {
  const {
    products,
    isLoading,
    isRefetching,
    error,
    filterOptions,
    selectedFilters,
    hasSelectedFilters,
    applyFilters,
    goToPage,
  } = useCollectionSearch(collection);

  if (isLoading) {
    return (
      <div className={styles.results}>
        <Results.Loading description="Loading products" />
      </div>
    );
  }
  if (error || !products) {
    return (
      <div className={styles.results}>
        <Results.FetchError error={error} entityName="product" />
      </div>
    );
  }

  return (
    <div className={styles.results}>
      {/* Outside the empty check: filters must survive a zero-result state, or narrowing to nothing
          removes the only control that could undo it. */}
      <ProductCardListHeader
        paginator={products.paginator}
        isRefetching={isRefetching}
        entityName="result"
        filterOptions={filterOptions}
        filters={selectedFilters}
        onChange={applyFilters}
        showFilters={collection.show_filters}
      />
      {products.results.length ? (
        <ProductCardList
          results={products.results}
          listSource={listSource}
          paginator={products.paginator}
          listContext={{
            collectionSlug: collection.slug,
            numResults: products.paginator.count,
          }}
          onPageChange={goToPage}
          entityName="result"
        />
      ) : (
        <Results.None
          header="No products found"
          description={hasSelectedFilters ? "Try removing a filter." : undefined}
        />
      )}
    </div>
  );
};

export default CollectionResults;
